<template>
  <jee-aside-layout class="smart-container">
    <section slot="asideHeader">
      <el-button
        size="medium"
        type='primary'
        @click="handleHeaderCreate"
        class="new-grouping"
        :disabled="!this._checkPermission('/letterBoxType', 'POST')"
      ><jee-icon iconClass="xinjian"/>新建分类</el-button>
      <form-dialog
        ref="addLetterBoxType"
        title="新建分类"
        :loading="addLetterBoxTypeLoading"
        :form="addLetterBoxTypeForm"
        :rules="addLetterBoxTypeRules"
        :formItems="addLetterBoxTypeFormItems"
        v-on:handleConfirm="handleConfirmLetterBoxTypeCreate"
      ></form-dialog>
    </section>
    <section slot="asideMain" class="smart-grouping" v-loading='listLoading'>
      <div class="smart-grouping-row smart-grouping-row-hover" @click="chooseGroupingAll"
      :class="{'jee-click': groupingId === ''}" style="cursor: pointer;">全部信箱 <span style="margin-left: 5px;"
      v-if='groupingAmount'>({{groupingAmount}})</span></div>
      <div>
        <div class="smart-grouping-row jee-hover-color3 smart-grouping-row-hover"
        v-for="(item,index) in letterBoxTypeList" :key="index" @click="chooseLetterBoxType(item)">
          <div class="grouping-name" v-if="!item.isName">
            <!-- <span class="grouping-label">{{item.id}}</span> -->
            <p class="grouping-name-text" :class="{'jee-click': groupingId === item.id}">
              <span v-if='item.name'>{{item.name}}</span>
              <span v-if='item.formCount'>({{item.formCount}})</span>
            </p>
          </div>
          <div class="grouping-icon" v-if="!item.isName">
            <jee-icon iconClass="bianji" class="jee-hover-fill" @click="item.isName=true"/>
            <jee-icon iconClass="delete" class="jee-hover-fill" @click="letterBoxTypeDelete(item)"/>
          </div>
          <div v-if="item.isName" class="grouping-newname">
            <el-input size="small" v-model="item.newName" :maxlength="15">
              <template class="newname-append" slot="append"><el-button slot="trigger" size="small" class="jee-bg-light-important" @click="editLetterBoxType(item)">确定</el-button></template>
            </el-input>
          </div>
        </div>
      </div>
      <el-dialog
        title="提示"
        width="500px"
        @close="handleCancelGrouping"
        :visible.sync="msgDialog.visible"
        class="smart-delete-dialog"
      >
        <span class="dialog-content">
          <i class="el-icon-warning"/>{{msgDialog.content}}
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleCancelGrouping" type='empty'>取消</el-button>
          <el-button size="small" type="primary" @click="handleConfirmGrouping">删除</el-button>
          <el-button size="small" type="primary" @click="handleConfirmGroupingno">不删除</el-button>
        </span>
      </el-dialog>
    </section>
    <section slot="main">
      <base-header
        v-bind="letterBoxHeaders"
        @handleNewFrom="handleHeaderNewFrom"
        @handleDelete="handleHeaderDelete"
      />

      <search-header
        class="search-header"
        v-bind="searchHeader"
        :params="list.params"
        @handleSearch="handleSearchs"
      ></search-header>
      <base-table
        v-bind="list"
        v-on:handleEdit="handleEdit"
        v-on:handleDelete="handleTableDelete"
        v-on:handleSelectionChange="handleSmartSelect"
        v-on:handleSizeChange="handleSizeChange"
        v-on:handleCurrentChange="handleCurrentChange"
      >
      <template #name="scope">
        <div class="jee-color title-box">
          <div @click="toLinkAddress(scope.scope.row)" v-if="scope.scope.row.viewStatus===1||scope.scope.row.viewStatus===2">
            <jee-icon iconClass="lianjiexingyinyong"></jee-icon>
          </div>
          <p class="smart-title" @click="editForm(scope.scope.row)">{{scope.scope.row.name}}</p>
        </div>
      </template>
      <template #boxType="scope">
        <div class="jee-hover-color" style="cursor: pointer;" @click="alterLetterBoxType(scope.scope.row)" v-if="scope.scope.row.boxType&&scope.scope.row.boxType.name">
         {{scope.scope.row.boxType.name}}
         <i class="el-icon-caret-bottom"></i>
        </div>
      </template>
      <template #joinCount="scope">
        <p v-if="scope.scope.row.joinCount===0">0</p>
        <p v-if="scope.scope.row.joinCount>0" @click="gotoStatistics(scope.scope.row)" style="cursor: pointer;" class="jee-color">{{scope.scope.row.joinCount}}</p>
      </template>
      </base-table>
      <form-dialog
        ref="addForm"
        v-bind="formEdit"
        :rules="rules"
        v-on:handleConfirm="handleConfirmForm"
        class="smart-add-from"
      ></form-dialog>
      <form-dialog
        ref="alterLetterBoxTypeForm"
        v-bind="alterLetterBoxTypeForm"
        :rules="alterLetterBoxTypeRules"
        v-on:handleConfirm="handleConfirmAlterLetterBoxType"
      ></form-dialog>
    </section>
  </jee-aside-layout>
</template>

<script>
import formDialog from '@/components/mixins/formDialog'
import baseHeader from '@/components/mixins/baseHeader'
import searchHeader from '@/components/mixins/searchHeader'
import baseTable from '@/components/mixins/baseTable'
const columns = [
  {
    prop: 'name',
    label: '信箱名称',
    minWidth: '145px',
    fixed: 'left',
    scopeType: 'slot'
  },
  {
    prop: 'boxType',
    label: '所属分类',
    minWidth: '130px',
    scopeType: 'slot'
  },
  {
    prop: 'adminUsernames',
    label: '管理员',
    minWidth: '130px'
  },
  {
    prop: 'createUser',
    label: '创建人',
    minWidth: '100px'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: '180px'
  },
]
export default {
  mixins: [formDialog, baseHeader, searchHeader, baseTable],
  name: 'letterBox',
  components: {},
  data () {
    return {
      listLoading: false,
      addLetterBoxTypeLoading: false,
      addLetterBoxTypeForm: {
        name: ''
      },
      addLetterBoxTypeRules: {
        name: [
          this.$rules.required(),
          {
            validator: (rule, value, callback) => {
              if (value) {
                var params = {
                  name: value
                }
                this.$request.fetchLetterBoxTypeUnique(params).then(res => {
                  if (res.code === 200 && res.data) {
                    callback()
                  } else {
                    callback(new Error('分类名称不能重复'))
                  }
                })
              }
            },
            trigger: 'blur'
          }
        ]
      },
      addLetterBoxTypeFormItems: [
        {
          prop: 'name',
          label: '分类名称',
          maxlength: 15
        }
      ],
      formEdit: {
        loading: false,
        title: '新建',
        form: {
          id: null,
          name: '',
          boxTypeId: null,
          userId: []
        },
        formItems: [
          {
            prop: 'name',
            label: '信箱名称',
            maxlength: 15
          },
          {
            prop: 'boxTypeId',
            label: '信箱分类',
            type: 'select',
            options: []
          },
          {
            prop: 'userId',
            label: '管理员',
            type: 'select',
            multiple: true,
            options: []
          }
        ],
        buttons: [
          {
            text: '保存并编辑字段',
            type: 'Submit',
            href: '/system/organize/permission'
          },
          {
            text: '保存',
            type: 'Submit'
          }
        ]
      },
      alterLetterBoxTypeForm: {
        loading: false,
        title: '修改分类',
        form: {
          boxTypeId: '',
          id: ''
        },
        formItems: [
          {
            type: 'select',
            prop: 'boxTypeId',
            label: '分类',
            options: []
          }
        ],
        buttons: [
          {
            text: '确定',
            type: 'Submit'
          }
        ]
      },
      alterLetterBoxTypeRules: {
        boxTypeId: [this.$rules.required()]
      },
      letterBoxTypeList: [],
      groupingAmount: '',
      notGroupFormCount: '',
      groupingId: '',
      msgDialog: {
        content: '是否删除分类内的信箱',
        visible: false,
        params: {
          ids: [],
          cascadeDelForm: ''
        }
      },
      letterBoxHeaders: {
        showAlertIcon: false,
        buttons: [
          {
            type: 'NewFrom',
            text: '新建信箱',
            icon: 'xinjian',
            disabled: !this._checkPermission('/letterBox', 'POST')
          },
          {
            type: 'Delete',
            text: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/letterBox', 'DELETE')
          }
        ]
      },
      searchHeader: {
        searchItems: [
          {
            type: 'searchInput',
            value: 'name',
            placeholder: '请输入信箱名称',
            style: {
              width: '330px'
            }
          }
        ]
      },
      list: {
        params: {
          boxTypeId: '',
          name: ''
        },
        columns,
        api: 'fetchLetterBoxPage',
        handleColumn: [
          {
            type: 'Delete',
            name: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/letterBox', 'DELETE')
          },
        ],
        handleColumnProp: {
          label: '操作',
          width: '100',
          fixed: 'right'
        }

      },
      allOptions: []
    }
  },
  computed: {
    rules () {
      return {
        title: [
          this.$rules.required(),
          {
            validator: (rule, value, callback) => {
              if (value) {
                var params = {
                  title: value,
                  id: this.formEdit.form.id || ''
                }
                this.$request.fetchLetterBoxUnique(params).then(res => {
                  if (res.code === 200) {
                    if (res.data) {
                      callback()
                    } else {
                      callback(new Error('信箱名称不能重复'))
                    }
                  } else {
                    callback()
                  }
                })
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    // 表格多选操作
    handleSmartSelect (data) {
      var ids = data.map(v => v[this.list.rowKey || 'id'])
      this.list.selectedKeys = ids
    },
    // 弹窗新建分类
    handleHeaderCreate () {
      this.$refs.addLetterBoxType.showDialog()
    },
    // 获取管理员列表
    fetchSystemUserslist() {
      this.$request.fetchSystemUserslist().then(res => {
        if (res.code === 200) {
           this.formEdit.formItems.find(d => d.prop === 'userId').options = res.data.map(d => {
            d.label = d.realname ? d.realname : d.username
            d.value = d.id
            return d
          })
          console.log(this.formEdit)
        }
      })
    },
    // 分类列表信息
    fetchLetterBoxTypeList () {
      this.listLoading = true
      this.$request.fetchLetterBoxTypeList().then(res => {
        if (res.code === 200) {
          this.letterBoxTypeList = res.data.map(d => {
            d.newName = d.name
            d.isName = false
            return d
          })
          this.alterLetterBoxTypeForm.formItems.find(d => d.prop === 'boxTypeId').options = res.data.map(d => {
            d.label = d.name
            d.value = d.id
            return d
          })
          this.formEdit.formItems.find(d => d.prop === 'boxTypeId').options = res.data.map(d => {
            d.label = d.name
            d.value = d.id
            return d
          })
          this.groupingAmount = res.data.formTotalCount
          this.notGroupFormCount = res.data.notGroupFormCount
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 新建分类
    handleConfirmLetterBoxTypeCreate (data) {
      this.addLetterBoxTypeLoading = true
      this.$request.fetchLetterBoxTypeAdd(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchLetterBoxTypeList()
        }
        this.addLetterBoxTypeLoading = false
      }).catch(() => {
        this.addLetterBoxTypeLoading = false
      })
    },
    // 修改名字
    editLetterBoxType (data) {
      if (data.newName === data.name) {
        data.isName = false
      } else {
        if (!data.newName) {
          this.$message({
            message: '请输入分组名',
            type: 'warning'
          })
          return
        }
        var params = {
          name: data.newName,
          id: data.id
        }
        this.$request.fetchLetterBoxTypeUnique(params).then(res => {
          if (res.code === 200) {
            this.$request.fetchLetterBoxTypeAlter(params).then(res => {
              if (res.code === 200) {
                data.name = data.newName
                this.fetchTableApi()
                this.$message({
                  message: '操作成功',
                  type: 'success'
                })
                data.isName = false
              }
            })
          } else {
            this.$message({
              message: '分类名重复不可用',
              type: 'warning'
            })
          }
        })
      }
    },
    // 选择分组
    chooseLetterBoxType (data) {
      this.groupingId = data.id
      this.list.params.boxTypeId = data.id
      this.fetchTableApi()
    },
    chooseGroupingAll () {
      this.groupingId = ''
      this.list.params.boxTypeId = ''
      this.fetchTableApi()
    },
    chooseGroupingNo () {
      this.groupingId = 0
      this.list.params.boxTypeId = 0
      this.fetchTableApi()
    },
    // 删除分组
    letterBoxTypeDelete (data) {
      this.msgDialog.params.ids = [data.id]
      this.msgDialog.visible = true
    },
    // 删除分组弹窗
    handleCancelGrouping () {
      this.msgDialog.visible = false
    },
    // 删除分组弹窗
    handleConfirmGrouping () {
      this.msgDialog.params.cascadeDelForm = true
      this.$request.fetchLetterBoxTypeDelete(this.msgDialog.params).then(res => {
        if (res.code === 200) {
          this.fetchLetterBoxTypeList()
          this.groupingId = ''
          this.list.params.boxTypeId = ''
          this.fetchTableApi()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.msgDialog.visible = false
        }
      })
    },
    // 删除分组弹窗
    handleConfirmGroupingno () {
      this.msgDialog.params.cascadeDelForm = false
      this.$request.fetchLetterBoxTypeDelete(this.msgDialog.params).then(res => {
        if (res.code === 200) {
          this.fetchLetterBoxTypeList()
          this.groupingId = ''
          this.list.params.boxTypeId = ''
          this.fetchTableApi()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.msgDialog.visible = false
        }
      })
    },
    // 新建表单
    handleHeaderNewFrom () {
      this.formEdit.title = '新建'
      this.formEdit.form = {
        name: '',
        // description: ''
      }
      this.$refs.addForm.showDialog()
    },
    // 确认新表单
    handleConfirmForm (data, btn) {
      console.log(data)
      this.formEdit.loading = true
      let boxTypeId = ''
      if (this.groupingId === 0) {
        boxTypeId = ''
      } else {
        boxTypeId = this.groupingId
      }
      let params = {
        boxTypeId: boxTypeId,
        ...data
      }
      if (data.id) {
        console.log('这里')
        this.$request.fetchLetterBoxAlter(params).then(res => {
          if (res.code === 200) {
            if (btn.href) {
              this.fetchTableApi()
              this.fetchLetterBoxTypeList()
              this.$routerLink('/interact/smart/detail', 'link', { id: res.data, state: 0 })
            } else {
              this.fetchLetterBoxTypeList()
              this.fetchTableApi()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }
          }
          this.formEdit.loading = false
        }).catch(() => {
          this.formEdit.loading = false
        })
      } else {
        console.log('再这里')
        this.$request.fetchLetterBoxAdd(params).then(res => {
          console.log(res.data)
          if (res.code === 200) {
            if (btn.href) {
              this.fetchTableApi()
              this.fetchLetterBoxTypeList()
              this.$routerLink('/interact/letter/box/detail', 'link', { id: res.data, state: 0 })
            } else {
              this.fetchTableApi()
              this.fetchLetterBoxTypeList()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
            }
          }
          this.formEdit.loading = false
        }).catch(() => {
          this.formEdit.loading = false
        })
      }
    },
    // 编辑表单
    editForm (data) {
      this.formEdit.title = '编辑'
      this.formEdit.form = Object.assign(this.formEdit.form, data)
      // 设置userId
      var userId = [];
      let admins = this.formEdit.form.admins
      if (null != admins && admins.length > 0) {
        admins.map(user => {
          userId.push(user.id);
        })
      }
      this.formEdit.form.userId = userId;
      this.$refs.addForm.showDialog()
    },
    // 头部删除
    handleHeaderDelete () {
      if (this.list.selectedKeys.length > 0) {
        this.$confirm('删除表单连同表单中的数据一起删除，是否确定删除表单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ids = this.list.selectedKeys
          this.fetchLetterBoxDelete(ids)
        })
      } else {
        this.$message('请选择需要操作的数据')
      }
    },
    // 列表搜索
    handleSearchs () {
      this.fetchTableApi()
    },
    // 表格数据
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content.map(d => {
          if (d.viewStatus === 0) {
            d.hiddenStop = true
          } else if (d.viewStatus === 1 || d.viewStatus === 2) {
            d.hiddenIssue = true
          }
          if (d.joinCount === 0) {
            d.disabledDerive = true
            d.disabledEmpty = true
          }

          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    },
    // 图标链接跳转
    toLinkAddress (row) {
      this.$routerLink('/interact/letter/box/detail', 'Edit', { link: 'linkAddress', state: row.viewStatus, id: row.id })
    },
    // 标题跳转
    toEdit (row) {
      if (row.viewStatus === 1 || row.viewStatus === 2) {
        this.$confirm('此表单处于进行中状态，编辑表单时表单会暂停发布，将导致正在填写此表单的用户无法提交而必须重新填写，是否继续？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {}
          data.ids = [row.id]
          data.publish = false
          this.fetchSmartFormPublishPut(data)
          this.$routerLink('/interact/letter/box/detail', 'link', { id: row.id, state: 0 })
        }).catch(() => {})
      } else {
        this.$routerLink('/interact/letter/box/detail', 'link', { id: row.id, state: row.viewStatus })
      }
    },
    // 表格跳统计
    gotoStatistics (row) {
      this.$routerLink('/interact/letter/box/detail', 'link', { link: 'statistical', id: row.id, state: row.viewStatus })
    },
    // 表格编辑
    handleEdit (data) {
      this.toEdit(data)
    },
    // 表格删除
    handleTableDelete (row) {
      this.$confirm('删除表单连同表单中的数据一起删除，是否确定删除表单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [row.id]
        this.fetchLetterBoxDelete(ids)
      })
    },
    // 表单删除
    fetchLetterBoxDelete (ids) {
      this.$request.fetchLetterBoxDelete({ ids }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchTableApi()
          this.fetchLetterBoxTypeList()
        }
      })
    },
    // 修改分组
    alterLetterBoxType (row) {
      console.log(row)
      // this.alterLetterBoxTypeForm.form.id = row.id
      // this.alterLetterBoxTypeForm.form.boxTypeId = row.boxType.id

      this.alterLetterBoxTypeForm.form = Object.assign(this.alterLetterBoxTypeForm.form, row)

      this.$refs.alterLetterBoxTypeForm.showDialog()
    },
    // 修改分类确定
    handleConfirmAlterLetterBoxType (data) {
      console.log(data)
      this.alterLetterBoxTypeForm.loading = true
      this.$request.fetchLetterBoxAlter(data).then(res => {
        console.log(res.data)
        if (res.code === 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.fetchLetterBoxTypeList()
          this.fetchTableApi()
        }
        this.alterLetterBoxTypeForm.loading = false
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.fetchSystemUserslist()
      this.fetchLetterBoxTypeList()
    })
  },
  activated () {
    this.fetchTableApi()
  }
}
</script>

<style lang="scss">
.smart-container{
  .smart-delete-dialog .dialog-footer button:first-child:hover{
    color: #ffffff !important;
    border-color: #1EC6DF !important;
  }
  .base-header-container header .button-list-wrap .el-button{
    margin-bottom: 0;
  }
  .el-main.scrollbar::-webkit-scrollbar{
    display: none;
  }
  .base-header-container{
    padding-top: 11px;
  }
  .smart-grouping{
    font-size: 14px;
    color: #333333;
    .smart-grouping-row{
      padding: 13px 10px;
      display: flex;
      line-height: 1.5;
      .grouping-label{
          color: #333333;
          margin-right: 10px;
        }
      .grouping-name{
        display: flex;
        align-items: center;
        fill: #333333;
        cursor: pointer;
        flex: 6;
        .grouping-name-text{
          word-wrap: break-word;
          span{
            word-wrap: break-word;
          }
        }
      }
      .grouping-icon{
        display: flex;
        align-items: center;
        width: 44px;
        flex: 2;
        svg{
          color: #777;
          fill: #777;
          margin-left: 10px;
          cursor: pointer;
          font-size: 12px;
          display: none;
        }
      }
      .grouping-newname{
        margin-top: -5px;
        .el-input__inner{
          padding: 0 10px;
        }
      }
    }
    .smart-grouping-row:hover svg{
      display: block;
    }
    .smart-grouping-row-hover:hover{
      background-color: #F3F3F3;
    }
    .dialog-footer .el-button.el-button--empty:first-child{
      border-color: #E8E8E8;
      color: #333;
    }
  }
  .title-box{
    display: flex;
    cursor: pointer;
    svg{
      margin-right: 10px;
    }
  }
  .form-status{
    padding: 15px 0;
    .title{
      font-size: 14px;
    }
    .time{
      font-size: 12px;
      color: #999999;
    }
  }
  .unpublished{
    .title{
      color: #666;
    }
  }
  .underway{
    .title{
      color: #6AC043;
    }
  }
  .finished{
    .title{
      color: #FC0D1B;
    }
  }
  .smart-add-from{
    .el-textarea .el-textarea__inner{
      line-height: 1.5 !important;
    }
  }
  // 1440以下时表格间距
  @media screen and (max-width: 1440px) {
    .el-table .cell{
      padding-left: 15px;
      padding-right: 15px;
      &:first-of-type{
        padding-left: 10px;
        padding-right: 10px;
      }
    }
    .el-table tr td:last-child{
      .cell{
        padding-left: 10px;
        padding-right: 10px;
      }
      .el-table tr td:last-child{
        .cell{
          padding-left: 15px;
          padding-right: 5px;
        }
      }
      .el-table tr td:first-child{
        .cell{
          padding-left: 10px;
          padding-right: 0px;
        }
      }
    }

  }
  // 1440以上时表格间距
  @media screen and (min-width: 1440px) {
    .el-table .cell{
      padding-left: 25px;
      padding-right: 25px;
      &:first-of-type{
        padding-left: 10px;
        padding-right: 10px;
      }
    }
    .el-table tr td:last-child{
      .cell{
        padding-left: 10px;
        padding-right: 10px;
      }
      .el-table tr td:last-child{
        .cell{
          padding-left: 15px;
          padding-right: 5px;
        }
      }
      .el-table tr td:first-child{
        .cell{
          padding-left: 10px;
          padding-right: 0px;
        }
      }
    }

  }
}
</style>
